import React from "react";
import "../../styles/global.css"
import logo from "../../assets/logo/newLogo.svg"

const Loader = () => {
  return (
    <div className="loaderWrapper">
  <div className="loaderCircle">
    <img src={logo} alt="Logo" className="logo" />
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
  </div>
</div>
  );
};

export default Loader;
